import { render, staticRenderFns } from "./smsbutton.vue?vue&type=template&id=8e064d70&scoped=true&"
import script from "./smsbutton.vue?vue&type=script&lang=js&"
export * from "./smsbutton.vue?vue&type=script&lang=js&"
import style0 from "./smsbutton.vue?vue&type=style&index=0&id=8e064d70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e064d70",
  null
  
)

export default component.exports